import { Box } from '@mui/material';
import { AnnualPercentYieldForm } from './annualPercentForm';
import { InitialDepositForm } from './InitialDepositForm';
import { TermLengthForm } from './termLengthForm';
import { TermLengthUnitToggle } from './termLengthForm/TermLengthUnitToggle';

export function CalculatorForm() {
  return (
    <Box
      component="form"
      data-testid="calculator-form"
      sx={{
        backgroundColor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        width: '100%',
      }}
    >
      <InitialDepositForm />
      <AnnualPercentYieldForm />
      <TermLengthForm />
      <TermLengthUnitToggle />
    </Box>
  );
}
